<template>
  <div class="error-con">
    <div class="error-text">对不起，您请求的页面不存在、或已被删除、或暂时不可用</div>
    <div class="second-con"><span class="second">{{ second }}</span> 秒后将自动返回云柑社区首页</div>
    <div class="btn-con">
      <div class="btn btn-first" @click="goReturn">返回上一页</div>
      <div class="" style="width: 40px;"></div>
      <div class="btn" @click="goMall">返回首页</div>
    </div>
  </div>
</template>

<script>
export default {
  components: {

  },
  data(){
    return {
      second: 5,
      timer: null,
    }
  },
  created(){
    this.autoGoMall()
  },
  methods: {
    autoGoMall(){
      this.timer = window.setInterval(()=>{
        this.second--
        console.log(this.timer)
        if(this.second===0){
          this.clear()
          this.goMall()
        }
      },1000)
    },
    goReturn(){
      this.$router.go(-1)
    },
    goMall(){
      this.$router.push({name: 'mall'})
    },
    clear(){
      window.clearInterval(this.timer)
    }
  },
  beforeDestroy(){
    if(this.timer){
      this.clear()
    }
  }
}
</script>

<style lang="less" scoped>
.error-con{
  position: absolute;width: 100%;height: 100%;z-index: 0;
  background-color: #f5f5f5;
  .error-text{
    padding: 160px 60px 40px;
    font-size: 16px;
    color: #545454;
    text-align: center;
  }
  .second-con{
    font-size: 14px;color: #999;text-align: center;
    .second{color: #e82924;}
  }

  .btn-con{
    padding: 60px 40px 0;
    display: flex;justify-content: center;align-items: center;
    .btn{
      display: inline-flex;justify-content: center;align-items: center;
      font-size: 14px;color: #00a6ff;
      border: 1px solid #00a6ff;border-radius: 15px;
      padding: 4px 16px;
    }
  }
}
</style>